import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Cotizador from "@/pages/Cotizador";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Login from "@/pages/Login";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function AdminRoute({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return <div className="min-h-screen flex items-center justify-center overline text-muted-foreground">Verificando sesión…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    if (user.role !== "admin") return <Navigate to="/me" replace />;
    return children;
}

function CustomerRoute({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return <div className="min-h-screen flex items-center justify-center overline text-muted-foreground">Verificando sesión…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-center" richColors />
                    <Routes>
                        <Route path="/" element={<Cotizador />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/me" element={<CustomerRoute><CustomerDashboard /></CustomerRoute>} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}
